import { createSlice } from '@reduxjs/toolkit';
import { merge, reduce } from 'lodash';

import { ENTITY_TYPES } from 'src/constants';

const initialState = reduce(
  ENTITY_TYPES,
  (result) => {
    result = merge(
      {
        actualIncome: null,
        loading: false,
      },
    );
    return result;
  },
  {},
);

const slice = createSlice({
  name: 'actualIncome',
  initialState,
  reducers: {
    createActualIncomeStart(state, { payload }) {},
    createActualIncomeSuccess(state, { payload }) {
    },
    createActualIncomeFailure(state, { payload }) {},
    getActualIncomeStart(state, { payload }) {
      state.loading = true;
    },
    getActualIncomeSuccess(state, { payload }) {
      const { response } = payload;
      state.actualIncome = response;
      state.loading = false;
    },
    getActualIncomeFailure(state, { payload }) {},
    editActualIncomeStart(state, { payload }) {
      state.loading = true;
    },
    editActualIncomeSuccess(state, { payload }) {
      const { response } = payload;
      state.loading = false;
      state.actualIncome = response;
    },
    editActualIncomeFailure(state, { payload }) {},
  },
});

export const { actions } = slice;

export default slice.reducer;
